<template>
  <div :class="['form-log-discuss', showTab && 'show-tab']" :style="{right}">
    <span class="form-log-discuss-arrow" @click="showTabPane">
      <i :class="['el-icon-arrow-left', showTab && 'arrow-right']"></i>
    </span>
    <el-tabs class="form-log-discuss-tabs" :value="activeName">
      <el-tab-pane :label="`讨论${discussCount}`" name="discuss" v-if="form.properties.enableDiscuss">
        <discuss-component :dataId="dataId" :defineId="defineId" :formId="form.id" :dataState="dataState"
                           @discuss-preview-image="discussPreviewImage"
                           @setDiscussCount="setDiscussCount"></discuss-component>
      </el-tab-pane>
      <el-tab-pane label="日志" name="log" v-if="form.properties.enableLog">
        <log-component ref="log" :dataId="dataId" :dataState="dataState"></log-component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LogComponent from './log-component'
import DiscussComponent from './discuss-component'
import { watchResize } from '@utils'

export default {
  name: 'discuss-log-component',
  props: {
    defineId: String,
    form: Object,
    dataId: String,
    dataState: String
  },
  components: {
    LogComponent,
    DiscussComponent
  },
  data () {
    return {
      discussCount: '(0)',
      showTab: true,
      right: '-259px'
    }
  },
  computed: {
    activeName () {
      if (this.form.properties.enableDiscuss) {
        return 'discuss'
      } else {
        return 'log'
      }
    }
  },
  methods: {
    showTabPane () {
      this.showTab = !this.showTab
      this.$emit('showDiscussOrLogTabPane', this.showTab)
    },
    setDiscussCount (num) {
      this.discussCount = num ? `(${num})` : '(0)'
    },
    discussPreviewImage (url) {
      this.$emit('discuss-preview-image', url)
    }
  },
  mounted () {
    // 滚动条出现的时候在讨论要左移
    const self = this
    watchResize(this.$parent.$el.querySelector('.form-layout-run'), entries => {
      // 父容器高度
      const parentHeight = this.$parent.$el.querySelector('.el-main').getBoundingClientRect().height
      // 子节点高度
      const domHeight = entries[0].target.getBoundingClientRect().height
      // 如果有滚动条的情况下是 -286px
      // 没有的话是 -295px;
      self.right = domHeight > parentHeight ? '-286px' : '-295px'
      console.log('123')
    })
  }
}
</script>

<style lang="scss">
  .form-log-discuss{
    width: 320px;
    height: 100%;
    position: absolute;
    padding-left: 25px;
    transition: transform .3s;
    &.show-tab{
      transform: translateX(-295px);
    }
    .form-log-discuss-arrow{
      width: 24px;
      height: 24px;
      background-color: var(--light-9, #ECF6FD);
      cursor: pointer;
      position: absolute;
      top: 5px;
      left: 0;
      line-height: 24px;
      text-align: center;
      .el-icon-arrow-left{
        color: var(--primary, #54ABF1);
        transition: transform .3s;
        &.arrow-right{
          transform: rotate(180deg);
        }
      }
    }
    .form-log-discuss-tabs.el-tabs{
      border-left: 1px solid #ECECEC;
      height: 100%;
      .el-tabs__header{
        .el-tabs__nav-wrap::after{
          height: 1px;
        }
        .el-tabs__nav{
          .el-tabs__item{
            width: 90px;
            text-align: center;
          }
        }
      }

      .el-tabs__content{
        height: calc(100% - 55px);
        .el-tab-pane{
          padding: 0 10px 10px;
          height: 100%;
          min-height: 400px;
          overflow-y: scroll;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/discussLogComponents/discuss-log-component.vue